import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { TestNavigationChildPage } from 'pages/test-navigation-child/test-navigation-child';

@NgModule({
    declarations: [TestNavigationChildPage],
    imports: [PagesModule, ComponentsModule]
})
export class TestNavigationChildPageModule {}
